var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToothache({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1740,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M753.36 298.356c-59.04-55.932-164.444-27.444-199.86-15.628a37.82 37.82 0 0 1-23.956 0c-35.412-11.816-140.82-40.304-199.86 15.628-96.78 85.052-28.348 213.396 6.98 266.408 11.268 16.908 17.428 36.656 18.076 56.964 3.752 117.384 27.376 229.58 63.64 229.58 39.632 0 43.404-45.292 43.404-146.38 0-48.06 18.024-76.628 36.928-93.372 24.264-21.492 61.344-21.492 85.608 0 18.908 16.748 36.928 45.316 36.928 93.372 0 101.088 3.776 146.38 43.408 146.38 36.264 0 59.888-112.192 63.64-229.58 0.648-20.308 6.808-40.056 18.076-56.964 35.336-53.012 103.768-181.356 6.988-266.408z",
    fill: "#FFFFFF",
    "p-id": 1742
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M753.36 298.356c-32.632-30.916-79.424-36.02-120.74-32.424 28.356 2.8 56.216 11.932 77.844 32.424 96.78 85.048 28.348 213.396-6.98 266.408-11.268 16.908-17.428 36.656-18.076 56.964-3.084 96.532-19.616 189.496-45.56 219.5 6.096 6.768 14.148 10.08 24.812 10.08 36.264 0 59.888-112.192 63.64-229.58 0.648-20.308 6.808-40.056 18.076-56.964 35.332-53.012 103.764-181.356 6.984-266.408z",
    fill: "#D5E6F7",
    "p-id": 1743
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M664.66 863.304c-55.408 0-55.408-66.432-55.408-158.38 0-36.672-11.068-65.064-32.888-84.392-9.54-8.448-21.916-13.1-34.848-13.1-12.928 0-25.304 4.652-34.844 13.1-21.824 19.328-32.888 47.72-32.888 84.392 0 91.944 0 158.38-55.408 158.38-66.024 0-74.848-216.508-75.632-241.196-0.584-18.264-6.14-35.792-16.072-50.688-36.172-54.276-109.04-190.356-5.084-281.928 25.716-24.268 61.588-36.572 106.632-36.572 43.408 0 84.488 11.544 105.112 18.428a25.96 25.96 0 0 0 16.364 0c20.624-6.884 61.708-18.428 105.112-18.428 45.044 0 80.916 12.304 106.632 36.572 103.952 91.572 31.084 227.652-5.084 281.928-9.928 14.9-15.484 32.428-16.072 50.692-0.78 24.684-9.608 241.192-75.624 241.192z m-123.14-279.872c18.804 0 36.832 6.796 50.76 19.136 18.692 16.556 40.972 47.752 40.972 102.356 0 51.836 1.064 86.164 6.496 108.228 5.936 24.132 15.564 26.152 24.912 26.152 18.26 0 47.16-77.616 51.648-217.96 0.724-22.744 7.672-44.608 20.084-63.236 32.688-49.052 99.012-171.676 9.044-250.736a7.856 7.856 0 0 1-0.332-0.304c-21.116-20.004-51.492-30.152-90.288-30.152-40.012 0-78.272 10.772-97.52 17.192a49.992 49.992 0 0 1-31.552 0c-19.248-6.42-57.508-17.192-97.52-17.192-38.792 0-69.172 10.144-90.288 30.152l-0.332 0.304c-89.968 79.06-23.644 201.684 9.044 250.74 12.416 18.624 19.364 40.492 20.084 63.236 4.484 140.344 33.388 217.96 51.648 217.96 9.348 0 18.972-2.02 24.912-26.152 5.432-22.064 6.496-56.392 6.496-108.228 0-54.608 22.28-85.804 40.972-102.356 13.932-12.344 31.96-19.14 50.76-19.14z",
    fill: "#504774",
    "p-id": 1744
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M470 392.024l-61.668 61.668L221 266.364l61.668-61.668z",
    fill: "#FD919F",
    "p-id": 1745
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M470 392.024l-61.668 61.668-62.356-62.356 61.668-61.668z",
    fill: "#E0667D",
    "p-id": 1746
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M408.328 465.692a11.984 11.984 0 0 1-8.484-3.516L212.516 274.844a12 12 0 0 1 0-16.972l61.668-61.668a12 12 0 0 1 16.968 0l187.328 187.328a12 12 0 0 1 0 16.968l-61.668 61.668a11.96 11.96 0 0 1-8.484 3.524zM237.968 266.36l170.36 170.36 44.7-44.696-170.36-170.356L237.968 266.36z",
    fill: "#504774",
    "p-id": 1747
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M408.328 204.692l61.668 61.668-187.328 187.328L221 392.02z",
    fill: "#FD919F",
    "p-id": 1748
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M450.288 246.652l19.708 19.708-187.328 187.328-19.708-19.708z",
    fill: "#E0667D",
    "p-id": 1749
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282.668 465.692a11.984 11.984 0 0 1-8.484-3.516l-61.668-61.668a11.992 11.992 0 0 1 0-16.968l187.328-187.328a12 12 0 0 1 16.968 0L478.48 257.88a12 12 0 0 1 0 16.972l-187.328 187.332a12.012 12.012 0 0 1-8.484 3.508zM237.968 392.024l44.7 44.696 170.36-170.36-44.7-44.696-170.36 170.36z",
    fill: "#504774",
    "p-id": 1750
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothache);
export default __webpack_public_path__ + "static/media/toothache.8f8db9da56415ab90914f1e6adb02fa5.svg";
export { ForwardRef as ReactComponent };